const initialState = {
  occupation: [],
  education: [],
  age: [],
  caste: [],
  religion: [],
  bankAccount: [],
  familyIncome: [],
  babyWeight: [],
  familySize: [],
  household: [],
  getState: 0,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_OCCUPATION_FULFILLED':
      return { ...state, getState: 2, occupation: action.payload.data }
    case 'GET_OCCUPATION_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_OCCUPATION_PENDING':
      return { ...state, getState: 1 }

    case 'GET_EDUCATION_LEVEL_FULFILLED':
      return { ...state, getState: 2, education: action.payload.data }
    case 'GET_EDUCATION_LEVEL_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_EDUCATION_LEVEL_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AGE_FULFILLED':
      return { ...state, getState: 2, age: action.payload.data }
    case 'GET_AGE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AGE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_FAMILY_INCOME_FULFILLED':
      return { ...state, getState: 2, familyIncome: action.payload.data }
    case 'GET_FAMILY_INCOMEGE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_FAMILY_INCOME_PENDING':
      return { ...state, getState: 1 }

    case 'GET_FAMILY_BANK_ACCOUNT_FULFILLED':
      return { ...state, getState: 2, bankAccount: action.payload.data }
    case 'GET_FAMILY_BANK_ACCOUNT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_FAMILY_BANK_ACCOUNT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_CASTE_FULFILLED':
      return { ...state, getState: 2, caste: action.payload.data }
    case 'GET_CASTE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_CASTE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_RELIGION_FULFILLED':
      return { ...state, getState: 2, religion: action.payload.data }
    case 'GET_RELIGION_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_RELIGION_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AVERAGE_FAMILY_SIZE_FULFILLED':
      return { ...state, getState: 2, familySize: action.payload.data }
    case 'GET_AVERAGE_FAMILY_SIZE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AVERAGE_FAMILY_SIZE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AVERAGE_BABY_WEIGHT_FULFILLED':
      return { ...state, getState: 2, babyWeight: action.payload.data }
    case 'GET_AVERAGE_BABY_WEIGHT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AVERAGE_BABY_WEIGHT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AVERAGE_HOUSEHOLD_FULFILLED':
      return { ...state, getState: 2, household: action.payload.data }
    case 'GET_AVERAGE_HOUSEHOLD_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AVERAGE_HOUSEHOLD_PENDING':
      return { ...state, getState: 1 }
    default:
      return state
  }
}

export default reducer
